if (!customElements.get("facet-filters-form")) {
  class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.form = this.querySelector("form");
      this.onSubmitHandler = this.onSubmitHandler.bind(this);
      this.onChangeHandler = this.onChangeHandler.bind(this);
      this.onPopStateHandler = this.onPopStateHandler.bind(this);
    }

    connectedCallback() {
      if (!this.form) return;

      this.form.addEventListener("submit", this.onSubmitHandler);
      this.form.addEventListener("change", this.onChangeHandler);
      window.addEventListener("popstate", this.onPopStateHandler);

      this.sortButtons = this.querySelectorAll('.sort-by-option');
      this.sortButtonClickHandler = (event) => {
        const sortByValue = event.currentTarget.dataset.sortBy;

        let hiddenInput = this.form.querySelector('input[name="sort_by"]');

        if (hiddenInput) {
          hiddenInput.value = sortByValue;
        } else {
          hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'sort_by';
          hiddenInput.value = sortByValue;
          this.form.appendChild(hiddenInput);
        }

        document.querySelectorAll('.sort-by-option span').forEach(el => {
          el.classList.remove('underline');
        });

        event.currentTarget.querySelector('span').classList.add('underline');

        const detailsElement = event.currentTarget.closest('details');
        if (detailsElement) {
          detailsElement.removeAttribute('open');
        }

        this.renderPage();
      };

      this.sortButtons.forEach(button => {
        button.addEventListener('click', this.sortButtonClickHandler);
      });

      this.activeFiltersContainer = document.querySelector('[data-active-filters]');

      if (this.activeFiltersContainer) {
        this.activeFiltersClickHandler = (e) => {
          const link = e.target.closest('a');
          if (!link) return;

          e.preventDefault();

          const url = new URL(link.href);
          const searchParams = url.searchParams.toString();

          this.renderFromUrl(searchParams, true);
        };

        this.activeFiltersContainer.addEventListener(
            'click',
            this.activeFiltersClickHandler
        );
      }

      this.filterCheckboxes = this.form.querySelectorAll('input[type="checkbox"]');
      this.filterCheckboxClickHandler = (event) => {
        const detailsElement = event.target.closest('details');
        if (detailsElement) {
          detailsElement.removeAttribute('open');
        }
      };

      this.filterCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('click', this.filterCheckboxClickHandler);
      });
    }

    disconnectedCallback() {
      if (!this.form) return;

      this.form.removeEventListener("submit", this.onSubmitHandler);
      this.form.removeEventListener("change", this.onChangeHandler);
      window.removeEventListener("popstate", this.onPopStateHandler);

      this.sortButtons.forEach(button => {
        button.removeEventListener('click', this.sortButtonClickHandler);
      });

      if (this.activeFiltersContainer) {
        this.activeFiltersContainer.removeEventListener(
            'click',
            this.activeFiltersClickHandler
        );
      }

      if (this.filterCheckboxes) {
        this.filterCheckboxes.forEach(checkbox => {
          checkbox.removeEventListener('click', this.filterCheckboxClickHandler);
        });
      }
    }

    onSubmitHandler(event) {
      event.preventDefault();
      this.renderPage();
    }

    onChangeHandler() {
      this.renderPage();
    }

    onPopStateHandler() {
      this.renderFromUrl(window.location.search.replace(/^\\?/, ""));
    }

    createSearchParams() {
      const formData = new FormData(this.form);
      const searchParams = new URLSearchParams();

      for (const [key, value] of formData.entries()) {
        if (value !== "") {
          searchParams.append(key, value);
        }
      }

      return searchParams.toString();
    }

    renderPage() {
      const searchParams = this.createSearchParams();
      this.renderFromUrl(searchParams, true);
    }

    renderFromUrl(searchParams, updateHistory = false) {
      const url = `${window.location.pathname}?section_id=${this.sectionId}${searchParams ? `&${searchParams}` : ""}`;

      this.classList.add("is-loading");

      fetch(url, {
        method: "GET",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      })
      .then((response) => response.text())
      .then((responseText) => {
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(responseText, "text/html");

        const currentSection = document.querySelector(
            `#CollectionSection-${this.sectionId}`,
        );
        const newSection = newDocument.querySelector(
            `#CollectionSection-${this.sectionId}`,
        );

        if (!currentSection || !newSection) return;

        const partsToUpdate = [
          '#Details-Mobile-Sort-',
          '.filters-container',
          '[data-active-filters]',
          '[data-product-grid]',
          '[data-products-count]',
          '[data-pagination-container]',
          '#mobile-facets'
        ];

        partsToUpdate.forEach(selector => {
          const currentEl = document.querySelector(selector.includes('#') ? `${selector}${this.sectionId}`: selector);
          const newEl = newDocument.querySelector(selector.includes('#') ? `${selector}${this.sectionId}`: selector);
          if (currentEl && newEl) {
            currentEl.innerHTML = newEl.innerHTML;
          }
        });

        if (updateHistory) {
          const nextUrl = `${window.location.pathname}${searchParams ? `?${searchParams}` : ""}`;
          window.history.pushState({}, "", nextUrl);
        }
      })
      .catch((error) => {
        console.error("Filter update error:", error);
      })
      .finally(() => {
        this.classList.remove("is-loading");
        this.disconnectedCallback();
        this.connectedCallback();
      });
    }
  }

  customElements.define("facet-filters-form", FacetFiltersForm);
}


document.addEventListener('DOMContentLoaded', function() {
  const openFilterButton = document.querySelector('.js-open-filter');
  const closeFilterButton = document.querySelector('#filter-sidebar .closebtn');
  const filterSidebar = document.getElementById('filter-sidebar');
  const applyFiltersButton = document.querySelector('.js-apply-filters');
  const clearFiltersButton = document.querySelector('.js-clear-filters');
  const mobileForm = document.getElementById('FacetFiltersFormSidebar');
  const desktopForm = document.querySelector('.collection-facets:not(.mobile) form');

  if (openFilterButton && filterSidebar) {
    openFilterButton.addEventListener('click', function() {
      filterSidebar.classList.add('is-visible');
      document.body.classList.add('modal-opened');
    });
  }

  if (closeFilterButton && filterSidebar) {
    closeFilterButton.addEventListener('click', function() {
      filterSidebar.classList.remove('is-visible');
      document.body.classList.remove('modal-opened');
    });
  }

  function syncCheckboxes(sourceForm, targetForm) {
    const sourceCheckboxes = sourceForm.querySelectorAll('input[type="checkbox"]');
    sourceCheckboxes.forEach(sourceCheckbox => {
      const targetCheckbox = targetForm.querySelector(`input[name="${sourceCheckbox.name}"][value="${sourceCheckbox.value}"]`);
      if (targetCheckbox) {
        targetCheckbox.checked = sourceCheckbox.checked;
      }
    });
  }

  if (mobileForm && desktopForm) {
    mobileForm.addEventListener('change', function(e) {
      if (e.target.type === 'checkbox') {
        syncCheckboxes(mobileForm, desktopForm);
        desktopForm.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  if (applyFiltersButton && filterSidebar) {
    applyFiltersButton.addEventListener('click', function() {
      filterSidebar.classList.remove('is-visible');
      document.body.classList.remove('modal-opened');
    });
  }

  if (clearFiltersButton) {
    clearFiltersButton.addEventListener('click', function() {
      const collectionUrl = clearFiltersButton.dataset.collectionUrl;
      if (collectionUrl) {
        window.location.href = collectionUrl;
      }
    });
  }
});
